// Copyright (C) 2022 Intel Corporation
//
// SPDX-License-Identifier: MIT

import './styles.scss';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import {Job } from 'cvat-core-wrapper';
import { useDispatch, useSelector } from 'react-redux';
import Spin from 'antd/lib/spin';
import { Col, Row } from 'antd/lib/grid';
import Empty from 'antd/lib/empty';
import Text from 'antd/lib/typography/Text';

import { updateHistoryFromQuery } from 'components/resource-sorting-filtering';
import { CombinedState, Indexable } from 'reducers';
import { getJobsAsync } from 'actions/jobs-actions';

import TopBarComponent from '../jobs-page/top-bar';
import JobList from './job-list';

interface Props {
    users: any[];
    submissions: any[];
    jobs: any[];
    count: number;
    fetching: boolean;
    onJobsUpdate: (jobs: Job[]) => Promise<void>;
}
function JobsComponent(props: Props): JSX.Element {

    return (
        <div className='cvat-assignment-page'>
            <Row justify='space-around' about='middle'>
                <Col sm={23}>
                    <JobList
                        jobs={props.jobs}
                        onUpdateJobs={props.onJobsUpdate}
                        submissions={props.submissions}
                        users={props.users}
                        fetching={props.fetching}
                    />
                </Col>
            </Row>
        </div>
    );
}

export default React.memo(JobsComponent);
